import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { School, Trees, BookOpen, Building2, Handshake } from 'lucide-react';

// Import the existing page components
import AdminPartnerSchoolsPage from './AdminPartnerSchoolsPage';
import AdminPartnerPage from './AdminPartnerPage';
import AdminMarketplacePage from './AdminMarketplacePage';

export default function AdminPartnersHubPage() {
  const [activeTab, setActiveTab] = useState('marketplace');

  return (
    <div className="space-y-6" data-testid="admin-partners-hub-page">
      <div>
        <h1 className="font-heading text-2xl font-bold">Partners</h1>
        <p className="text-muted-foreground">Manage marketplace partners, school districts, partner schools, libraries, parks, and other partners</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-5 lg:w-auto lg:inline-flex">
          <TabsTrigger value="marketplace" className="flex items-center gap-2">
            <Handshake className="h-4 w-4" />
            <span className="hidden sm:inline">Marketplace</span>
          </TabsTrigger>
          <TabsTrigger value="schools" className="flex items-center gap-2">
            <School className="h-4 w-4" />
            <span className="hidden sm:inline">Schools</span>
          </TabsTrigger>
          <TabsTrigger value="libraries" className="flex items-center gap-2">
            <BookOpen className="h-4 w-4" />
            <span className="hidden sm:inline">Libraries</span>
          </TabsTrigger>
          <TabsTrigger value="parks" className="flex items-center gap-2">
            <Trees className="h-4 w-4" />
            <span className="hidden sm:inline">Park Districts</span>
          </TabsTrigger>
          <TabsTrigger value="other" className="flex items-center gap-2">
            <Building2 className="h-4 w-4" />
            <span className="hidden sm:inline">Other Partners</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="marketplace" className="mt-6">
          <AdminMarketplacePage embedded />
        </TabsContent>

        <TabsContent value="schools" className="mt-6">
          <SchoolsTab />
        </TabsContent>
        <TabsContent value="libraries" className="mt-6">
          <LibrariesTab />
        </TabsContent>
        <TabsContent value="parks" className="mt-6">
          <ParksTab />
        </TabsContent>
        <TabsContent value="other" className="mt-6">
          <AdminPartnerPage embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
}

// Schools Tab - Shows School Districts + Partner Schools with internal tabs
function SchoolsTab() {
  const [subTab, setSubTab] = useState('districts');
  
  return (
    <Tabs value={subTab} onValueChange={setSubTab} className="w-full">
      <TabsList className="mb-4">
        <TabsTrigger value="districts" className="flex items-center gap-2">
          <Building2 className="h-4 w-4" />
          School Districts
        </TabsTrigger>
        <TabsTrigger value="schools" className="flex items-center gap-2">
          <School className="h-4 w-4" />
          All Schools
        </TabsTrigger>
      </TabsList>
      <TabsContent value="districts">
        <AdminPartnerSchoolsPage embedded defaultTab="districts" showOnlySchools />
      </TabsContent>
      <TabsContent value="schools">
        <AdminPartnerSchoolsPage embedded defaultTab="schools" showOnlySchools />
      </TabsContent>
    </Tabs>
  );
}

// Libraries Tab - Focused on libraries only
function LibrariesTab() {
  return <AdminPartnerSchoolsPage embedded defaultTab="libraries" showOnlyLibraries />;
}

// Parks Tab - Focused on park districts only
function ParksTab() {
  return <AdminPartnerSchoolsPage embedded defaultTab="parks" showOnlyParks />;
}
